import styled from "styled-components";

import { PendingReviewMessage } from "pages/[tenant]/g/[group_slug]/classwork/[topic_slug]/[activitie_slug]/components/organisms/LessonCommentsFeed/components/molecules/CommenterInfo/styles";
import { UserLevelContainer } from "pages/[tenant]/g/components/Feed/components/UserLevel/styles";

import { SimpleUserPhotoContainer } from "shared/components/atoms/SimpleUserPhoto/styles";

export const FeedPostUserContainer = styled.div`
  grid-area: user;

  > div {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  ${PendingReviewMessage} {
    align-self: self-start;

    margin-bottom: 12px;

    text-wrap: initial;

    svg {
      min-width: 14px;
      min-height: 14px;
    }
  }

  .user-image {
    position: relative;
  }

  .texts {
    display: flex;
    flex-direction: column;

    .user-info {
      display: flex;
      gap: 8px;

      :not(:has(.usertitle)) {
        align-items: center;
      }

      .username {
        font: 500 0.875rem/1.3125rem "Inter";
        color: ${({ theme }) => theme.feed.usernameColor};

        a {
          all: inherit;

          display: -webkit-box;
          overflow: hidden;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-word;
          :hover {
            cursor: pointer;
          }
        }
      }
    }

    .usertitle {
      font: 400 0.875rem/1.3125rem "Inter";
      color: #97a0ad;
    }
  }

  ${UserLevelContainer} {
    position: absolute;
    top: 20px;
    right: -8px;

    pointer-events: none;

    img {
      filter: initial;
    }
  }

  ${SimpleUserPhotoContainer} {
    img {
      width: 40px;
      height: 40px;
    }
  }
`;
